/*
 * Copyright (C) 2014 Spanning Cloud Apps. LLC  All rights reserved.
 */
import './daterangepicker.user.tpl.html';

angular
  .module('shared.daterangepicker', [])
  /**
   * Controller for the DateRangePicker template.
   */
  .controller('DateRangePickerCtrl', function ($scope, $injector) {
    // Lookup the store provider for the picker.
    var PickerStore = $injector.get($scope.storeName),
      minDate,
      maxDate;

    // Create two stores for each of the date pickers
    $scope.pickerStoreMin = new PickerStore();
    $scope.pickerStoreMax = new PickerStore();

    /**
     * Method to initialize the min date for the date range.
     * @param {date} minDate - The the min date to initialize the calendar with.
     */
    $scope.initMinDate = function (minDate) {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      $scope.pickerStoreMin.date = minDate || date;
      $scope.pickerStoreMin.selectDate = minDate || date;
    };

    /**
     * Method to initialize the max date for the date range.
     * @param {date} maxDate - The the max date to initialize the calendar with.
     */
    $scope.initMaxDate = function (maxDate) {
      var date = maxDate || new Date();
      $scope.pickerStoreMax.date = date;
      $scope.pickerStoreMax.selectDate = date;
    };

    // Initialize the values for the two basic date pickers.
    minDate = $scope.range ? $scope.range.minDate : null;
    maxDate = $scope.range ? $scope.range.maxDate : null;
    $scope.initMaxDate(maxDate);
    $scope.initMinDate(minDate);

    // Watch the values of the two basic date pickers and update the range values.
    $scope.$watch(
      function () {
        return $scope.pickerStoreMin.selectDate;
      },
      function (newVal) {
        if (newVal) {
          $scope.range.minDate = newVal.valueOf();
        }
      }
    );

    $scope.$watch(
      function () {
        return $scope.pickerStoreMax.selectDate;
      },
      function (newVal) {
        if (newVal) {
          $scope.range.maxDate = newVal.valueOf();
        }
      }
    );
  })
  /**
   * The directive for the date range picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   */
  .directive('daterangepicker', function () {
    return {
      templateUrl: 'shared/daterangepicker/daterangepicker.user.tpl.html',
      scope: {
        storeName: '@storeName',
        range: '='
      },
      controller: 'DateRangePickerCtrl'
    };
  });
